import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { KEYS } from '../../constants/keys.js';
import { mergeProps } from '../../utils/react.js';
import { noop } from '../../utils/util.js';
import { ListItem } from '../ListItem/ListItem.js';
import { useMenuContext } from '../Menu/MenuContext.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["as", "itemIndex", "onActivate"];
var defaultElement = "li";
var MenuItem = /*#__PURE__*/React.forwardRef(function MenuItem2(props, ref) {
  var _props$as = props.as,
    as = _props$as === void 0 ? defaultElement : _props$as,
    itemIndex = props.itemIndex,
    _props$onActivate = props.onActivate,
    onActivate = _props$onActivate === void 0 ? noop : _props$onActivate,
    rest = _objectWithoutProperties(props, _excluded);
  var menuContext = useMenuContext();
  var handleKeyDown = function handleKeyDown(e) {
    switch (e.key) {
      case KEYS.ENTER:
        {
          onActivate(e);
          break;
        }
      case KEYS.SPACE:
        {
          onActivate(e);
          e.preventDefault();
          break;
        }
    }
  };
  var itemProps = mergeProps(rest, !props.disabled ? {
    onClick: onActivate,
    onKeyDown: handleKeyDown
  } : {});
  var content;
  switch (as) {
    case "a":
      content = /*#__PURE__*/jsx(ListItem, _objectSpread(_objectSpread({
        as: as
      }, itemProps), {}, {
        ref: ref
      }));
      return /*#__PURE__*/jsx("li", {
        role: "none",
        children: menuContext !== null && menuContext !== void 0 && menuContext.getItemRender ? menuContext.getItemRender(content, itemIndex) : content
      });
    case "li":
      content = /*#__PURE__*/jsx(ListItem, _objectSpread(_objectSpread({
        as: as
      }, itemProps), {}, {
        ref: ref
      }));
      return menuContext !== null && menuContext !== void 0 && menuContext.getItemRender ? menuContext === null || menuContext === void 0 ? void 0 : menuContext.getItemRender(content, itemIndex) : content;
    default:
      content = /*#__PURE__*/React.createElement(as, _objectSpread(_objectSpread({}, itemProps), {}, {
        ref: ref
      }));
      return /*#__PURE__*/jsx("li", {
        role: "none",
        children: menuContext !== null && menuContext !== void 0 && menuContext.getItemRender ? menuContext === null || menuContext === void 0 ? void 0 : menuContext.getItemRender(content, itemIndex) : content
      });
  }
});
MenuItem.displayName = "MenuItem";

export { MenuItem };
